import React, { ReactElement } from "react";
import {
  VermogensRekening,
  SpaarrekeningenHoofdstuk,
} from "../../../../.generated/rapportage/rapportagetypes";
import { Chapter } from "../../components/Chapter";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { Paragraph } from "../../components/Paragraph";
import { generateRandomString } from "ts-randomstring/lib";
import { getVermogenColumns } from "../Producten/vermogen-kolommen";

type SpaarrekeningenBeleggingsdepotChapterProps = {
  hoofdstuk: SpaarrekeningenHoofdstuk;
};

const getSpaarrekeningenBeleggingsdepotTable = (
  vermogensrekening: VermogensRekening
): ReactElement => {
  const columns = getVermogenColumns(vermogensrekening.soortProduct ?? "");
  const data: VermogensRekening[] = [vermogensrekening];

  return (
    <Table
      columns={columns}
      data={data}
      id="vermogensrekeningen-table"
      rotate
    ></Table>
  );
};

const SpaarrekeningenBeleggingsdepotChapter = ({
  hoofdstuk,
}: SpaarrekeningenBeleggingsdepotChapterProps): ReactElement => {
  return (
    <Chapter>
      <div className="break-avoid">
        {hoofdstuk.titel && <Heading text={hoofdstuk.titel} level={3} />}
        <Paragraph>{hoofdstuk?.paragrafen?.p305060301?.inhoud}</Paragraph>

        {hoofdstuk.spaarrekeningen?.slice(0, 1).map((spaarrekening) => (
          <React.Fragment key={`vermogensrekening-${generateRandomString()}`}>
            {getSpaarrekeningenBeleggingsdepotTable(spaarrekening)}
          </React.Fragment>
        ))}
      </div>
      {hoofdstuk.spaarrekeningen?.slice(1).map((spaarrekening, index) => (
        <React.Fragment
          key={`vermogensrekening-${generateRandomString()}-${index + 1}`}
        >
          {getSpaarrekeningenBeleggingsdepotTable(spaarrekening)}
        </React.Fragment>
      ))}
    </Chapter>
  );
};

export default SpaarrekeningenBeleggingsdepotChapter;
